<fuse-highlight lang="json" [code]="details | json">
</fuse-highlight>